import {scoreBadge} from "../../utilities/general"

export const SupportScoresRow = ({nhsr}) => {
    const supportScore = nhsr?.categories?.["Orientation Support"]
    const supportBadge = scoreBadge(supportScore?.val, supportScore?.max)
    const preceptorScore = nhsr?.categories?.["Preceptor Rating"]
    const preceptorBadge = scoreBadge(preceptorScore?.val, preceptorScore?.max)

    return (
        <div className="row row-cols-1 row-cols-lg-2 g-10 mb-8">
            <div className="col">
                <div className="d-flex flex-column w-100 gap-5">
                    <div className="d-flex align-items-center w-100 flex-column">
                        <div className="d-flex justify-content-between w-100 mb-2">
                            <span className="fw-bold fs-5">Support Score</span>
                            <div className="fw-bold fs-5">
                                {supportScore?.mean != null ? Number(supportScore.mean).toFixed(1) : "Missing"}
                            </div>
                        </div>
                        {supportScore && (
                            <div className="h-10px mx-3 rounded w-100 bg-secondary">
                                <div
                                    className={`${supportBadge?.color} rounded h-8px`}
                                    role="progressbar"
                                    style={{
                                        width: `${supportScore.percent}%`,
                                    }}
                                ></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col">
                <div className="d-flex flex-column w-100 gap-5">
                    <div className="d-flex align-items-center w-100 flex-column">
                        <div className="d-flex justify-content-between w-100 mb-2">
                            <span className="fw-bold fs-5">Preceptorship Score</span>
                            <div className="fw-bold fs-5">
                                {preceptorScore?.mean != null ? Number(preceptorScore.mean).toFixed(1) : "Missing"}
                            </div>
                        </div>
                        {preceptorScore && (
                            <div className="h-10px mx-3 rounded w-100 bg-secondary">
                                <div
                                    className={`${preceptorBadge?.color} rounded h-8px`}
                                    role="progressbar"
                                    style={{
                                        width: `${preceptorScore.percent}%`,
                                    }}
                                ></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
